/**
 * Default location (Orlando, FL)
 */
export const DEFAULT_LOCATION = {
    latitude: 28.5383,
    longitude: -81.3792,
    address: 'Orlando, FL'
};

/**
 * Prayer calculation methods
 */
export const CALCULATION_METHODS = [
    { id: 0, name: 'Shia Ithna Ashari' },
    { id: 1, name: 'University of Islamic Sciences, Karachi' },
    { id: 2, name: 'Islamic Society of North America (ISNA)' },
    { id: 3, name: 'Muslim World League' },
    { id: 4, name: 'Umm al-Qura, Makkah' },
    { id: 5, name: 'Egyptian General Authority of Survey' },
    { id: 7, name: 'Institute of Geophysics, Tehran' },
    { id: 8, name: 'Gulf Region' },
    { id: 9, name: 'Kuwait' },
    { id: 10, name: 'Qatar' },
    { id: 11, name: 'Majlis Ugama Islam Singapura' },
    { id: 12, name: 'Union Organization Islamic de France' },
    { id: 13, name: 'Diyanet İşleri Başkanlığı, Turkey' },
    { id: 14, name: 'Spiritual Administration of Muslims of Russia' },
    { id: 15, name: 'Moonsighting Committee Worldwide' },
    { id: 16, name: 'Dubai' },
    { id: 17, name: 'JAKIM, Malaysia' },
    { id: 18, name: 'Tunisia' },
    { id: 19, name: 'Algeria' },
    { id: 20, name: 'KEMENAG, Indonesia' },
    { id: 21, name: 'Morocco' },
    { id: 22, name: 'Comunidade Islamica de Lisboa' },
    { id: 23, name: 'Ministry of Awqaf, Jordan' },
    { id: 99, name: 'Custom' }
];

/**
 * Juristic Methods (Asr calculation)
 */
export const JURISTIC_METHODS = [
    { id: 0, name: 'Standard (Shafi, Maliki, Hanbali)' },
    { id: 1, name: 'Hanafi' }
];

/**
 * High Latitude Adjustment Methods
 * Note: Updated to use numeric IDs for MUI compatibility
 */
export const HIGH_LATITUDE_METHODS = [
    { id: 0, name: 'None', value: 'NONE' },
    { id: 1, name: 'Middle of Night', value: 'NIGHT_MIDDLE' },
    { id: 2, name: '1/7th of Night', value: 'ONE_SEVENTH' },
    { id: 3, name: 'Angle Based', value: 'ANGLE_BASED' }
];

/**
 * Midnight Mode
 * Note: Updated to use numeric IDs for MUI compatibility
 */
export const MIDNIGHT_MODES = [
    { id: 0, name: 'Standard (Mid Sunset to Sunrise)', value: 'STANDARD' },
    { id: 1, name: 'Jafari (Mid Sunset to Fajr)', value: 'JAFARI' }
];

/**
 * Prayer names
 */
export const PRAYER_NAMES = [
    'Fajr',
    'Sunrise',
    'Dhuhr',
    'Asr',
    'Sunset',
    'Maghrib',
    'Isha',
    'Midnight'
];